import { useQuery } from "@tanstack/react-query";
import type { ContractUpdateResponse } from "../types";
import { axiosInstance } from "@follosoft/react-components";

export function useFetchContractUpdateService(signedParams: Record<string, string>) {
  const detailsUrl = signedParams.details_url;

  return useQuery<ContractUpdateResponse>({
    queryKey: ["contract-update", detailsUrl],
    queryFn: () => axiosInstance().get(detailsUrl).then((r) => r.data),
    enabled: !!detailsUrl,
    staleTime: Infinity,
    retry: false,
  });
}
